import { render, staticRenderFns } from "./ReviewArticleOriginalChangesPage.vue?vue&type=template&id=59561d50&"
import script from "./ReviewArticleOriginalChangesPage.vue?vue&type=script&lang=js&"
export * from "./ReviewArticleOriginalChangesPage.vue?vue&type=script&lang=js&"
import style0 from "./ReviewArticleOriginalChangesPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports